import errorHandler from '../transformers/axiosErrors'
import { ApiResponse } from '@/types'
import http from '@/api/v4/axiosInstance'
import { WWW_URL } from '@/lib/urls'

export const logIn = async (
  email: string,
  password: string
): Promise<ApiResponse> => {
  const resp: ApiResponse = { data: null, error: null }

  try {
    await http.get('/v4/sanctum/csrf-cookie')
    const response = await http.post('/v4/auth/login', {
      email,
      password,
    })

    resp.data = response.data
  } catch (e) {
    resp.error = errorHandler(e, {
      ignoreUnauthorized: true,
    })
  }

  return resp
}

export const logOut = async (): Promise<ApiResponse> => {
  const resp: ApiResponse = { data: null, error: null }

  try {
    const response = await http.delete('/v4/auth/logout')

    resp.data = response.data
  } catch (e) {
    resp.error = errorHandler(e)
  }

  return resp
}

export const register = async (
  email: string,
  password: string
): Promise<ApiResponse> => {
  const resp: ApiResponse = { data: null, error: null }

  try {
    const params = new URLSearchParams(window.location.search)
    const redirectQuery = params.get('redirect')
    let url = '/v4/auth/register'

    if (redirectQuery) {
      url += `?redirect=${encodeURIComponent(redirectQuery)}`
    }

    await http.get('/v4/sanctum/csrf-cookie')

    const response = await http.post(url, {
      email,
      password,
    })

    resp.data = response.data
  } catch (e) {
    resp.error = errorHandler(e)
  }

  return resp
}

export const fetchUser = async (): Promise<ApiResponse> => {
  const resp: ApiResponse = { data: null, error: null }
  try {
    const response = await http.get('/v4/auth/me')
    resp.data = response.data
  } catch (e) {
    resp.error = errorHandler(e)
  }
  return resp
}

export const disconnectSocialAccount = async (provider: string) => {
  const normalizedProvider = {
    google: 'google',
    facebook: 'facebook',
    'linkedin-openid': 'linkedin',
  }[provider]
  const resp: ApiResponse = { data: null, error: null }
  try {
    const response = await http.get(`/v4/auth/${normalizedProvider}/disconnect`, {
      baseURL: WWW_URL,
    })
    resp.data = response.data
  } catch (e) {
    resp.error = errorHandler(e)
  }
  return resp
}
